import "../../css/page/newInvoice.css";
import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../services/axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  InputLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { endpoint } from "../../utils/API";
import BasicTableProducts from "../../components/BasicTableProducts";
import BasicTableComments from "../../components/BasicTableComments";
import BasicTablePayments from "../../components/BasicTablePayments";
import INFOS from "../../utils/CompanyInfos";
import CreditNotePDF from "../../components/CreditNotePDF/CreditNotePDF";
import {
  Add,
  Person,
  Print,
  Receipt,
  Save,
  Settings,
  Storefront,
  TwoWheeler,
} from "@material-ui/icons";
import { Download, TireRepair } from "@mui/icons-material";
import ProductsTable from "../../components/Modals/ProductsTable";
import MaintenancesTable from "../../components/Modals/MaintenancesTable";
import VehiclesTable from "../../components/Modals/VehiclesTable";
import VehiclesUsedTable from "../../components/Modals/VehiclesUsedTable";
import ClientsTable from "../../components/Modals/ClientsTable";
import { TEMPLATE_CREDIT_NOTE } from "../../templates";
import Select from "@mui/material/Select";
import { getStructuredCommunication } from "../../services/Invoices/Invoices.service";

const CreditNote = () => {
  const { creditNoteId } = useParams();
  const [infos, setInfos] = useState({ ...INFOS });
  const [creditNoteNumber, setCreditNoteNumber] = useState();
  const [creditNoteDate, setCreditNoteDate] = useState("");
  const [inputCreditNoteDate, setInputCreditNoteDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [creditNoteProducts, setCreditNoteProducts] = useState([]);
  const [comments, setComments] = useState([]);
  const [payments, setPayments] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("Virement");
  const [client, setClient] = useState({
    ...TEMPLATE_CREDIT_NOTE.client,
  });
  const [item, setItem] = useState({});
  const [creditNote, setCreditNote] = useState({ ...TEMPLATE_CREDIT_NOTE });

  const [isModalAddMaintenanceOpen, setIsModalAddMaintenanceOpen] =
    useState(false);
  const [isModalAddProductOpen, setIsModalAddProductOpen] = useState(false);
  const [isModalAddVehicleOpen, setIsModalAddVehicleOpen] = useState(false);
  const [isModalAddQuantityOpen, setIsModalAddQuantityOpen] = useState(false);
  const [isModalAddVehicleUsedOpen, setIsModalAddVehicleUsedOpen] =
    useState(false);
  const [isModalAddClientOpen, setIsModalAddClientOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [newPaymentAmount, setNewPaymentAmount] = useState("");

  const fetchCreditNote = async () => {
    const { data } = await axiosInstance.get(`/creditNotes/${creditNoteId}`);

    if (data) {
      if (!data.success) {
        toast.error(data.message);
        return;
      }

      return data.result;
    }

    return null;
  };

  useEffect(() => {
    const getCreditNote = async () => {
      const result = await fetchCreditNote();

      setCreditNote(result);
      setInfos(result.infos);
      setCreditNoteNumber(result.creditNoteNumber);
      setCreditNoteDate(result.creditNoteDate);
      setCreditNoteDate(
        new Date(result.creditNoteDate).toISOString().split("T")[0]
      );
      setCreditNoteProducts(result.products);
      setComments(result.comments);
      setPayments(result.payments);
      setClient(result.client);
    };

    getCreditNote().catch((err) => console.log(err));
  }, []);

  const addClientToInvoice = async (e) => {
    const client = JSON.parse(e.target.dataset.params);

    if (!client) {
      closeModalAddClient();
      toast.error("Impossible d'ajouter le client !");

      return;
    }

    await updateToDatabase("client", client)
      .then(() => {
        setClient(client);
        closeModalAddClient();
        toast.success("Client assigné avec succès !");
      })
      .catch(() => toast.error("Erreur rencontrée !"));
  };

  const addItemToInvoice = (e) => {
    const item = JSON.parse(e.target.dataset.params);

    if (!item) {
      closeModalAddMaintenance();
      closeModalAddProduct();
      closeModalAddVehicle();
      closeModalAddVehicleUsed();
      toast.error("Impossible de trouver l'article !'");

      return;
    }

    setItem(item);
    openModalAddQuantity();
  };

  const addQuantity = async (e) => {
    e.preventDefault();

    const quantity = Number.parseFloat(e.currentTarget.quantity.value);

    if (isNaN(quantity)) {
      closeModalAddQuantity();
      toast.error("Quantité incorrecte !");

      return;
    }

    const existingProduct = creditNoteProducts.find(
      (creditNoteProduct) => creditNoteProduct._id === item._id
    );

    if (existingProduct) {
      const updatedExistingProduct = {
        ...existingProduct,
        quantity: existingProduct.quantity + quantity,
      };

      const updatedCreditNoteProducts = creditNoteProducts.map(
        (creditNoteProduct) => {
          if (creditNoteProduct._id === item._id) {
            return updatedExistingProduct;
          }

          return creditNoteProduct;
        }
      );

      await updateToDatabase("products", updatedCreditNoteProducts)
        .then(() => {
          setCreditNoteProducts(updatedCreditNoteProducts);
          closeModals();
        })
        .catch(() => toast.error("Erreur rencontrée !"));

      return;
    }

    const creditNoteProduct = {
      ...item,
      quantity: quantity,
    };

    await updateToDatabase("products", [
      ...creditNoteProducts,
      creditNoteProduct,
    ])
      .then(() => {
        setCreditNoteProducts([...creditNoteProducts, creditNoteProduct]);
        closeModals();
      })
      .catch(() => toast.error("Erreur rencontrée !"));
  };

  const addComment = async (e) => {
    e.preventDefault();

    if (newComment.length === 0) {
      toast.error("Veuillez ajouter un commentaire !");

      return;
    }

    updateToDatabase("comments", [...comments, newComment])
      .then(() => {
        setComments([...comments, newComment]);
        setNewComment("");
        toast.success("Commentaire ajouté avec succès !");
      })
      .catch(() => toast.error("Erreur rencontrée !"));
  };

  const handleCommentChange = (e) => {
    setNewComment(e.currentTarget.value);
  };

  const updateToDatabase = async (fieldToUpdate, fieldValue) => {
    if (!client._id || client._id === "") {
      toast.error("Veuillez sélectionner un client !");

      return;
    }

    const creditNoteToUpdate = {
      creditNoteDate: creditNoteDate,
      client: client,
      products: creditNoteProducts,
      infos: infos,
      payments: payments,
      comments: comments,
      [fieldToUpdate]: fieldValue,
    };

    return await axiosInstance
      .put(`${endpoint}/creditNotes/${creditNote._id}`, creditNoteToUpdate)
      .then((response) => response)
      .catch((err) => err);
  };

  const closeModals = () => {
    closeModalAddQuantity();
    closeModalAddMaintenance();
    closeModalAddProduct();
    closeModalAddVehicle();
    closeModalAddVehicleUsed();
  };

  useEffect(() => {
    setInfos((prevState) => ({
      ...prevState,
      structuredCommunication: getStructuredCommunication(
        creditNoteDate,
        creditNoteNumber
      ),
    }));
  }, [creditNoteDate, creditNoteNumber]);

  const generateCreditNoteNumber = () => {
    const year = new Date().getFullYear().toString().substring(2);
    const month = ("0" + (new Date().getMonth() + 1)).slice(-2);
    const day = ("0" + new Date().getDate()).slice(-2);
    const creditNoteNumber = (
      creditNote.creditNoteNumber
        ? "0000" + creditNote.creditNoteNumber
        : "00000"
    ).slice(-4);

    return `${year}${month}${day}${creditNoteNumber}`;
  };

  const openModalAddClient = useCallback(() => {
    setIsModalAddClientOpen(true);
  }, []);

  const closeModalAddClient = useCallback(() => {
    setIsModalAddClientOpen(false);
  }, []);

  const openModalAddMaintenance = useCallback(() => {
    setIsModalAddMaintenanceOpen(true);
  }, []);

  const closeModalAddMaintenance = useCallback(() => {
    setIsModalAddMaintenanceOpen(false);
  }, []);

  const openModalAddProduct = useCallback(() => {
    setIsModalAddProductOpen(true);
  }, []);

  const closeModalAddProduct = useCallback(() => {
    setIsModalAddProductOpen(false);
  }, []);

  const openModalAddVehicle = useCallback(() => {
    setIsModalAddVehicleOpen(true);
  }, []);

  const closeModalAddVehicle = useCallback(() => {
    setIsModalAddVehicleOpen(false);
  }, []);

  const openModalAddVehicleUsed = useCallback(() => {
    setIsModalAddVehicleUsedOpen(true);
  }, []);

  const closeModalAddVehicleUsed = useCallback(() => {
    setIsModalAddVehicleUsedOpen(false);
  }, []);

  const openModalAddQuantity = useCallback(() => {
    setIsModalAddQuantityOpen(true);
  }, []);

  const closeModalAddQuantity = useCallback(() => {
    setIsModalAddQuantityOpen(false);
  }, []);

  const applyCreditNoteNumber = async () => {
    if (!client._id || client._id === "") {
      toast.error("Veuillez sélectionner un client !");

      return;
    }

    if (creditNoteProducts.length === 0) {
      toast.error("Veuillez ajouter au moins un produit !");

      return;
    }

    updateToDatabase("applyCreditNoteNumber", true)
      .then((response) => {
        const result = response.data.result;

        setCreditNote(result);
        setInfos(result.infos);
        setCreditNoteNumber(result.creditNoteNumber);
        setCreditNoteDate(result.creditNoteDate);
        setCreditNoteProducts(result.products);
        setComments(result.comments);
        setPayments(result.payments);
        setClient(result.client);

        toast.success("Numéro de note de crédit associé avec succès !");
      })
      .catch(() => toast.error("Erreur rencontrée !"));
  };

  const printPDF = () => {
    const creditNotePDF = document.getElementById("creditNotePDF");

    if (!creditNotePDF) {
      return;
    }

    creditNotePDF.contentWindow.focus();
    creditNotePDF.contentWindow.print();
  };

  const addPayment = (e) => {
    e.preventDefault();

    const paymentAmount = Number.parseFloat(newPaymentAmount.replace(",", "."));

    const newPayment = {
      paymentDate: e.currentTarget.paymentDate.value,
      paymentAmount: paymentAmount,
      paymentMethod: e.currentTarget.paymentMethod.value,
    };

    if (newPayment.length === 0) {
      toast.error("Veuillez ajouter un paiement !");

      return;
    }

    updateToDatabase("payments", [...payments, newPayment])
      .then(() => {
        setPayments([...payments, newPayment]);
        setNewPaymentAmount("");
        toast.success("Paiment ajouté avec succès !");
      })
      .catch(() => toast.error("Erreur rencontrée !"));
  };

  const handlePaymentAmountChange = (e) => {
    setNewPaymentAmount(e.currentTarget.value);
  };

  const handleChangePaymentMethod = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleCreditNoteDateChange = (event) => {
    const date = new Date(event.target.value);

    if (isNaN(date.getTime())) {
      return;
    }

    const creditNoteDateIso = date.toISOString().split("T")[0];
    setInputCreditNoteDate(creditNoteDateIso);
  };

  const updateCreditNoteDate = () => {
    const date = new Date(inputCreditNoteDate);

    if (isNaN(date.getTime())) {
      return;
    }

    const creditNoteDateIso = date.toISOString();

    updateToDatabase("creditNoteDate", creditNoteDateIso)
      .then(() => {
        setCreditNoteDate(creditNoteDateIso);
        toast.success("Date modifiée avec succès !");
      })
      .catch(() => toast.error("Erreur rencontrée !"));
  };

  return (
    <div className="content">
      <div className="above-table">
        <div className="title-search-container">
          <div className="title">Modifier la note de crédit</div>
          <div className="invoice-number">
            <span>Note de crédit N° </span>
            <span>{creditNote.creditNoteNumber}</span>
          </div>
        </div>
        <div className="download-print-buttons">
          <PDFDownloadLink
            document={
              <CreditNotePDF
                creditNoteNumber={creditNoteNumber}
                creditNoteDate={creditNoteDate}
                client={client}
                infos={infos}
                creditNoteProducts={creditNoteProducts}
                comments={comments}
                payments={payments}
              />
            }
            fileName={generateCreditNoteNumber() + ".pdf"}
            style={{ textDecoration: "none" }}
          >
            {({ blob, url, loading, error }) => {
              if (loading)
                return (
                  <CircularProgress
                    size={24}
                    color="error"
                    style={{ margin: "0 130px" }}
                  />
                );
              if (error) return <div>Une erreur est survenue</div>;

              return (
                <div className="create-button">
                  <div className="create-button-icons">
                    <Download />
                  </div>

                  <span>Télécharger la note de crédit</span>
                </div>
              );
            }}
          </PDFDownloadLink>

          <div className="create-button" onClick={printPDF}>
            <div className="create-button-icons">
              <Print />
            </div>

            <span>Imprimer la note de crédit</span>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 40 }}>
        <div className="section">
          <div style={{ flex: 0.5 }}>
            <div className="addProductItem">
              {creditNoteNumber ? (
                <div className="create-button disabled">
                  <div className="create-button-icons">
                    <span>{creditNote.creditNoteNumber}</span>
                  </div>
                </div>
              ) : (
                <div className="create-button" onClick={applyCreditNoteNumber}>
                  <div className="create-button-icons">
                    <Receipt />
                  </div>
                  <span>Attribuer un numéro de note de crédit</span>
                </div>
              )}
            </div>

            <div className="divider" />

            <div className="addProductItem">
              <div className="clientInfos">
                {client._id ? (
                  <>
                    <span>N°{client.clientNumber}</span> -
                    <span>{client.firstname}</span>
                    <span>{client.lastname}</span>
                  </>
                ) : (
                  <span>Veuillez sélectionner un client</span>
                )}
              </div>
              <div>
                <div className="addProductItem">
                  <div className="create-button" onClick={openModalAddClient}>
                    <div className="create-button-icons">
                      <Person />
                    </div>
                    <span>Rechercher un client</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="divider" />

            <div className="search-products-container">
              <div className="addProductItem">
                <div
                  className="create-button"
                  onClick={openModalAddMaintenance}
                >
                  <div className="create-button-icons">
                    <Settings />
                  </div>
                  <span>Travail</span>
                </div>
              </div>

              <div className="addProductItem">
                <div className="create-button" onClick={openModalAddProduct}>
                  <div className="create-button-icons">
                    <Storefront />
                  </div>
                  <span>Produit</span>
                </div>
              </div>

              <div className="addProductItem">
                <div className="create-button" onClick={openModalAddVehicle}>
                  <div className="create-button-icons">
                    <TwoWheeler />
                  </div>
                  <span>Véhicule</span>
                </div>
              </div>

              <div className="addProductItem">
                <div
                  className="create-button"
                  onClick={openModalAddVehicleUsed}
                >
                  <div className="create-button-icons">
                    <TireRepair />
                  </div>
                  <span>Véhicule d'occasion</span>
                </div>
              </div>
            </div>

            {creditNoteProducts.length > 0 && (
              <BasicTableProducts
                invoiceProducts={creditNoteProducts}
                setInvoiceProducts={setCreditNoteProducts}
                updateToDatabase={updateToDatabase}
              />
            )}
          </div>

          <div style={{ flex: 0.5 }}>
            {comments.length > 0 && (
              <BasicTableComments
                comments={comments}
                setComments={setComments}
                updateToDatabase={updateToDatabase}
              />
            )}
            <form onSubmit={addComment}>
              <div className="addProductItem">
                <TextField
                  id="comment"
                  name="comment"
                  label="Commentaire"
                  variant="outlined"
                  multiline
                  rows={4}
                  value={newComment}
                  onChange={handleCommentChange}
                />
              </div>

              <button type="submit" className="create-button-outline">
                <div className="add-button-icons">
                  <Add />
                </div>
              </button>
            </form>

            <div className="divider" />

            {payments.length > 0 && (
              <BasicTablePayments
                payments={payments}
                setPayments={setPayments}
                updateToDatabase={updateToDatabase}
              />
            )}

            <form onSubmit={addPayment} style={{ marginBottom: 16 }}>
              <div style={{ display: "flex", gap: 16 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <label>Date du paiement</label>
                  <TextField
                    type="date"
                    name="paymentDate"
                    required
                    defaultValue={new Date().toISOString().split("T")[0]}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <label>Montant du paiement</label>
                  <TextField
                    inputProps={{ step: "0.01" }}
                    type="number"
                    placeholder="100"
                    name="paymentAmount"
                    required
                    value={newPaymentAmount}
                    onChange={handlePaymentAmountChange}
                  />
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputLabel id="paymentMethodLabel">
                  Méthode de paiement
                </InputLabel>
                <div style={{ display: "flex", gap: 16 }}>
                  <Select
                    labelId="paymentMethodLabel"
                    id="demo-simple-select"
                    name="paymentMethod"
                    value={paymentMethod}
                    onChange={handleChangePaymentMethod}
                    required
                    style={{ flex: 1 }}
                  >
                    <MenuItem value={"Virement"}>Virement</MenuItem>
                    <MenuItem value={"Espèces"}>Espèces</MenuItem>
                    <MenuItem value={"Chèque"}>Chèque</MenuItem>
                    <MenuItem value={"Bancontact"}>Bancontact</MenuItem>
                    <MenuItem value={"Mastercard"}>Mastercard</MenuItem>
                    <MenuItem value={"Visa"}>Visa</MenuItem>
                  </Select>

                  <button type="submit" className="create-button-outline">
                    <div className="add-button-icons">
                      <Add />
                    </div>
                  </button>
                </div>
              </div>
            </form>

            <div className="divider" />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              <label>Date de la note de crédit</label>
              <TextField
                type="date"
                required
                onBlur={updateCreditNoteDate}
                value={inputCreditNoteDate}
                onChange={handleCreditNoteDateChange}
              />
            </div>
          </div>

          <PDFViewer
            style={{ flex: 1, height: "75vh" }}
            showToolbar={false}
            id="creditNotePDF"
          >
            <CreditNotePDF
              infos={infos}
              creditNoteNumber={creditNoteNumber}
              creditNoteDate={creditNoteDate}
              creditNoteProducts={creditNoteProducts}
              comments={comments}
              client={client}
              payments={payments}
            />
          </PDFViewer>
        </div>
      </div>

      <ProductsTable
        isModalAddProductOpen={isModalAddProductOpen}
        closeModalAddProduct={closeModalAddProduct}
        addItemToInvoice={addItemToInvoice}
      />

      <MaintenancesTable
        isModalAddMaintenanceOpen={isModalAddMaintenanceOpen}
        closeModalAddMaintenance={closeModalAddMaintenance}
        addItemToInvoice={addItemToInvoice}
      />

      <VehiclesTable
        isModalAddVehicleOpen={isModalAddVehicleOpen}
        closeModalAddVehicle={closeModalAddVehicle}
        addItemToInvoice={addItemToInvoice}
      />

      <VehiclesUsedTable
        isModalAddVehicleOpen={isModalAddVehicleUsedOpen}
        closeModalAddVehicle={closeModalAddVehicleUsed}
        addItemToInvoice={addItemToInvoice}
      />

      <ClientsTable
        isModalAddClientOpen={isModalAddClientOpen}
        closeModalAddClient={closeModalAddClient}
        addClientToInvoice={addClientToInvoice}
      />

      <Dialog
        open={isModalAddQuantityOpen}
        onClose={closeModalAddQuantity}
        fullWidth
      >
        <DialogTitle>Ajouter une quantité</DialogTitle>
        <DialogContent>
          <form className="addProductForm" onSubmit={addQuantity}>
            <div className="addProductItem">
              <InputLabel htmlFor="quantity" required>
                Quantité
              </InputLabel>
              <Input
                type="number"
                name="quantity"
                required
                defaultValue={1}
                inputProps={{ step: "0.01" }}
              />
            </div>
            <button className="addProductButton">Ajouter la quantité</button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalAddQuantity}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreditNote;
